export function getKisaanBaseURL() {
    // const baseUrl = env === 'prod' ? 'apiv2.ninjacart.in' : 'nc-kisaan.trafyn.info';
    // let returnUrl = `https://${baseUrl}`;
    // return returnUrl;
    return process.env.APP_KISAN_URI;
}
export function getAdaptiveHubURI() {
    // const baseUrl =
    //   env === 'prod' ? 'apiv2.ninjacart.in/adaptive-hub' : 'apiv2.trafyn.info/adaptive-hub';
    // let returnUrl = `https://${baseUrl}`;
    // return returnUrl;
    return process.env.APP_ADAPTIVE_HUB_URI;
  }
  
export function getDiscoveryMetaApi(payload) {
    let url = `${getKisaanBaseURL()}/kisaan/discovery/p/metadata?deviceIdOrUserId=${payload.deviceIdOrUserId}`;

    if (payload.geoLatitude && payload.geoLongitude) {
        url += `&geoLatitude=${payload.geoLatitude}&geoLongitude=${payload.geoLongitude}`;
    }

    return url;
  }

const paths = {
    discoveryMetadata: (payload) => `${getDiscoveryMetaApi(payload)}`,
    getStreamTokenOnExpiry: (userId: string) =>
        `${getKisaanBaseURL()}/kisaan/auth/exchangeToken/${userId}?sync=Stream`,
    getCategory: () => `${getKisaanBaseURL()}/kisaan/categories/p/categories`,
    getCategoryVideo: () => `${getKisaanBaseURL()}/kisaan/categories/p/videos`
};

export default paths;